// Cookie consent helpers. We persist the user's choice in localStorage so we
// don't ask again, and emit a window event so anything that depends on consent
// (e.g. PostHog) can react without polling.
//
// Choices: "all" (essential + analytics) , "essential" (only strictly-necessary).
// Default = "essential" until the user actively opts in. This is the PECR /
// UK GDPR default-deny standard for non-essential cookies.

const STORAGE_KEY = "meditalk:cookie-consent:v1";
const EVENT = "meditalk-cookie-consent-change";

export function getCookieConsent() {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setCookieConsent(value) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore (private mode, quota exceeded, etc.)
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
}

export function clearCookieConsent() {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: null }));
}

export function onCookieConsentChange(cb) {
  const handler = (e) => cb(e.detail);
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}

export const COOKIE_CONSENT_ACCEPTED = "all";
export const COOKIE_CONSENT_ESSENTIAL = "essential";
